import { logger } from '@/config/logger';
import { env } from '@/env';

function detectEdge() {
    if (!('userAgentData' in globalThis.navigator)) {
        return false;
    }

    // @ts-expect-error
    // eslint-disable-next-line compat/compat
    return Boolean(globalThis.navigator.userAgentData.brands.find(brand => brand.brand === 'Microsoft Edge'));
}

function detectChromium() {
    if (!('chrome' in globalThis) || !('userAgentData' in globalThis.navigator)) {
        return null;
    }

    // @ts-expect-error
    // eslint-disable-next-line compat/compat
    return Boolean(globalThis.navigator.userAgentData.brands.find(brand => brand.brand === 'Chromium'));
}

function detectFirefox() {
    return Boolean(navigator.userAgent.split(' ').find(entry => entry.startsWith('Firefox')));
}

export function detectBrowser() {
    const result = (
        [
            ['edge', detectEdge()],
            ['firefox', detectFirefox()],

            // Fallback to Chromium detection as most general case (Brave, Chromium, Arc, etc.)
            ['chromium', detectChromium()],
        ] as const
    ).find(([_, matches]) => matches);

    if (!result) {
        return null;
    }

    return result[0];
}

export type ExtensionStoreBrowser = 'chrome' | 'edge' | 'firefox';

export interface ExtensionStore {
    browser: ExtensionStoreBrowser;
    url: string;
}

export function getExtensionStore(browser: ReturnType<typeof detectBrowser> = detectBrowser()): ExtensionStore {
    switch (browser) {
        case 'edge':
            return { browser: 'edge', url: env.VITE_EDGE_EXT_URL };

        case 'firefox':
            return { browser: 'firefox', url: env.VITE_FIREFOX_EXT_URL };

        default:
            return { browser: 'chrome', url: env.VITE_CHROME_EXT_URL };
    }
}

export function getStoreExtensionUrl() {
    try {
        const browser = detectBrowser();

        logger.debug('Browser detected:', browser);

        switch (browser) {
            case 'chromium':
                return env.VITE_CHROME_EXT_URL ?? null;

            case 'edge':
                return env.VITE_EDGE_EXT_URL ?? null;

            case 'firefox':
                return env.VITE_FIREFOX_EXT_URL ?? null;

            default:
                return null;
        }
    } catch (error) {
        logger.error(error);
        return null;
    }
}

export const extensionStoreUrl = getStoreExtensionUrl();
